const FilterBar = ({ view, setView, statusFilter, setStatusFilter }) => {
  return (
    <div className="flex justify-between mb-4">

      {/* VIEW SWITCH */}
      <div className="flex gap-2">
        <button
          onClick={() => setView("timeline")}
          className={view === "timeline" ? activeBtn : normalBtn}
        >
          Timeline
        </button>

        <button
          onClick={() => setView("table")}
          className={view === "table" ? activeBtn : normalBtn}
        >
          Table
        </button>
      </div>

      {/* STATUS FILTER */}
      <select
        value={statusFilter}
        onChange={e => setStatusFilter(e.target.value)}
        className="border rounded px-2 py-1"
      >
        <option>All</option>
        <option>Completed</option>
        <option>In Progress</option>
        <option>Pending</option>
      </select>
    </div>
  );
};

const activeBtn = "px-3 py-1 bg-blue-900 text-white rounded";
const normalBtn = "px-3 py-1 border rounded";

export default FilterBar;
